"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1806],{

/***/ 91806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30555);
/* harmony import */ var _styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32866);









const Studywithscholarship = ({ studyabroadjdata , jotformId , externalLink  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "study_scholarship",
        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().studyabroadjourney),
        style: {
            backgroundColor: studyabroadjdata?.sectionBgColor || "#FFF1EF"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: studyabroadjdata.sectionTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            xl: 6,
                            lg: 6,
                            md: 6,
                            sm: 12,
                            className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().worthgtrytext),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().OffersContent),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ulItem),
                                        children: studyabroadjdata?.sectionPoints?.length > 0 && studyabroadjdata?.sectionPoints?.map((abroaddata, ind)=>{
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: abroaddata
                                            }, ind);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().anchor),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                children: "Worth giving a try."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                onClick: ()=>{
                                                    !jotformId && router.push(externalLink);
                                                },
                                                className: `${(_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().btnReg)}${jotformId ? ` ${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(jotformId)}` : ""}`,
                                                children: studyabroadjdata.button?.label || "Register Now"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            xl: 6,
                            lg: 6,
                            md: 6,
                            sm: 12,
                            className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().worthgtry),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_onlineCounselling_module_scss__WEBPACK_IMPORTED_MODULE_5___default().stuImg),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    src: studyabroadjdata?.sectionImageUrl || "/images/degreegirl.png",
                                    alt: "whykc-icon-2.svg",
                                    width: 450,
                                    height: 360
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Studywithscholarship);


/***/ })

}]);